import auth from './auth.js';
export default angular.module('eventix.common.services.oauthHeaders',[auth])
/**
 * @ngdoc service
 * @name eventix.common.services.OAuthHeaders
 * @requires eventix.common.services.Auth
 * @description
 * HTTP injector to add OAuth token headers into every request and globally respond to
 * `401 - Unauthorized`
 */
/**
 * @ngdoc service
 * @name eventix.common.services.OAuthHeadersProvider
 * @description
 * HTTP injector to add OAuth token headers into every request and globally respond to
 * `401 - Unauthorized`
 */
    .provider('OAuthHeaders', function() {
        var tokenType = 'credentials';
        /**
     * Implements $httpInterceptor methods for handling OAuth token in every request
     */
        return {
        /**
         * @ngdoc method
         * @name eventix.common.services.OAuthHeadersProvider#setStorageKey
         * @methodOf eventix.common.services.OAuthHeadersProvider
         * @description
         * Configure which token should be sent along with HTTP requests, only `client_credentials` and `password` are currenty supported
         *
         * @param {String} grantType Grant type
         */
            setGrantType: function(grantType) {
                tokenType = grantType;
            },
            $get: /*@ngInject*/ function($rootScope, $q, OAuthTokens) {
                return {
                /**
                 * Add a oauth header if a token is available
                 *
                 * @param {Object} config HTTP request configuration object
                 * @returns {Object} HTTP request configuration object
                 */
                    request: function(config) {
                        let tokens = OAuthTokens[tokenType];
                        if(tokens && !/^(https?:)?\/\//.test(config.url))
                            config.headers.Authorization = tokens.access_token;
                        return config;
                    },
                    /**
                 * Respond to a 401 request, broadcasting the error
                 *
                 * @param {Object} response HTTP response object
                 * @returns {Object} HTTP response object
                 */
                    responseError: function(response) {
                        if(response.status === 401)
                            $rootScope.$broadcast('unauthorized');
                        return $q.reject(response);
                    }
                };
            }
        };
    }).name;
